require('./../../../src/config.js');
require('../components/loader/loader.js');
require('../components/loader/loader.css');

angular.module("app")
.controller("HomeCtrl", function ($http, $scope, $interval, LINKS, ENDPOINT_SEARCH, ENDPOINT_AGGREGATE) {
	var vm = this;	
	vm.loaded = false;
	vm.collections = [];

	// TODO 
	// aggiungi access
	// limita il numero di relazioni

	$http.post(ENDPOINT_SEARCH, {
	   "table": "data",
	   "fields": {
	       "id": 1,
	       "preferred_label": 1,
	       "representations": 1,
	       "related": 1,
		   "type_id.name": 1,
		   "colore_coll": 1,
		   'pref': 1
	   },
	    "query": {            
			"table": "ca_collections",
			"access" : {$in : [1,2]}         
        }
	}).then(function (result) {
	   	vm.loaded = true;
	   	if (result.data.count > 0)  {
			 		    
		    vm.collections = _.filter(result.data.data, function(i){
		    	if(!_.isEmpty(i.related)){
            		i.related = _.filter(i.related.ca_objects["is part of"], function(rel){
                		return rel.img != null;
					})
					shuffleArray(i.related);  
            		return true;            						
			    } else {
			    	return false;
			    }
			})

			vm.collections = _.chain(vm.collections)
			.map(e=>{
				e.ord = parseInt(_.split(e.id, '_')[1])
				return e
			})
			.sortBy('ord').value()

			console.log(vm.collections)
		  }
	});
	function shuffleArray(array) {
		var m = array.length, t, i;
	  
		// While there remain elements to shuffle
		while (m) {
		  // Pick a remaining element…
		  i = Math.floor(Math.random() * m--);
	  
		  // And swap it with the current element.
		  t = array[m];
		  array[m] = array[i];
		  array[i] = t;
		}
	  
		return array;
	  }
})


// WEBPACK FOOTER //
// ./src/js/pages/home.js